import React from 'react';

const Stock = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800">Reporte de Stock</h1>
        <p className="text-gray-600 mt-1">Revisa todos los productos que tienen stock disponible</p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="text-center py-12">
          <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
          </svg>
          <h3 className="mt-2 text-sm font-medium text-gray-900">Reporte de Stock</h3>
          <p className="mt-1 text-sm text-gray-500">Vista de todos los productos con stock disponible</p>
          <p className="mt-2 text-xs text-gray-400">Esta funcionalidad estará disponible próximamente</p>
        </div>
      </div>
    </div>
  );
};

export default Stock;

